exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".date-picker.disabled[data-v-1a2b77d8] {\n  pointer-events: none;\n}\n.date-picker input:focus + .actions.before[data-v-1a2b77d8] {\n  display: none;\n}\n.date-picker .input.invalid > input[data-v-1a2b77d8] {\n  border: 1px solid var(--color8);\n}\n.date-picker .actions[data-v-1a2b77d8] {\n  position: absolute;\n  display: flex;\n  top: 0.25rem;\n  line-height: 1rem;\n}\n.date-picker .actions.before[data-v-1a2b77d8] {\n  left: 0.375rem;\n}\n.date-picker .actions.before svg.layout-icons-required[data-v-1a2b77d8] {\n  fill: #bd181e;\n}\n.date-picker .actions.after[data-v-1a2b77d8] {\n  right: 0.375rem;\n}\n", ""]);

// exports
